<template>
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-12">
        <h3>CompTIA A+ – Fragenkatalog</h3>
        <div class="text-muted mb-3">
          {{ meta.certification }} · {{ meta.language }} · {{ meta.questionCount }} Fragen
        </div>

        <!-- Filter / Suche -->
        <div class="card mb-3">
          <div class="card-body">
            <div class="row g-2 align-items-end">
              <div class="col-12 col-md-3">
                <label class="form-label">Core</label>
                <select class="form-select" v-model="coreFilter">
                  <option value="ALL">Alle</option>
                  <option value="Core1">Core1</option>
                  <option value="Core2">Core2</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="form-label">Suche (Frage / Antworten / Erklärung)</label>
                <input
                  class="form-control"
                  v-model.trim="search"
                  placeholder="z.B. DHCP, RAID, BIOS, NAT …"
                />
              </div>

              <div class="col-12 col-md-3 d-grid">
                <button class="btn btn-outline-secondary" @click="resetFilter">
                  Filter zurücksetzen
                </button>
              </div>
            </div>

            <div class="form-check mt-3">
              <input class="form-check-input" type="checkbox" id="showExplain" v-model="showExplanations" />
              <label class="form-check-label" for="showExplain">
                Erklärungen anzeigen
              </label>
            </div>

            <div class="form-check mt-1">
              <input class="form-check-input" type="checkbox" id="onlyWrong" v-model="onlyCorrectHighlight" />
              <label class="form-check-label" for="onlyWrong">
                Richtige Antwort farblich hervorheben
              </label>
            </div>
          </div>
        </div>

        <!-- Ergebnis-Info -->
        <div class="alert alert-info py-2">
          Anzeige: <b>{{ filteredQuestions.length }}</b> / {{ allQuestions.length }}
        </div>

        <!-- Liste -->
        <div class="accordion" id="questionsAccordion">
          <div class="accordion-item" v-for="q in filteredQuestions" :key="q.id">
            <h2 class="accordion-header" :id="'h_' + q.id">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#c_' + q.id"
                aria-expanded="false"
                :aria-controls="'c_' + q.id"
              >
                <span class="me-2 badge text-bg-secondary">#{{ q.id }}</span>
                <span class="me-2 badge text-bg-light">{{ q.core }}</span>
                <span>{{ q.question }}</span>
              </button>
            </h2>

            <div
              class="accordion-collapse collapse"
              :id="'c_' + q.id"
              :aria-labelledby="'h_' + q.id"
              data-bs-parent="#questionsAccordion"
            >
              <div class="accordion-body">
                <div class="list-group">
                  <div
                    v-for="(text, key) in q.choices"
                    :key="key"
                    class="list-group-item d-flex justify-content-between align-items-start"
                    :class="choiceClass(q, key)"
                  >
                    <div>
                      <b class="me-2">{{ key }}:</b> {{ text }}
                    </div>
                    <span v-if="key === q.correct" class="badge text-bg-success">Richtig</span>
                  </div>
                </div>

                <div v-if="showExplanations" class="mt-3">
                  <div class="alert alert-light mb-0">
                    <b>Erklärung:</b> {{ q.explanation }}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div v-if="filteredQuestions.length === 0" class="alert alert-warning mt-3">
          Keine Treffer für deine Filter/Suche.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fragenkatalog from "@/assets/Fragenkatalog/CompTIA_Aplus.json";

export default {
  name: "AllQuestions",

  data() {
    return {
      meta: fragenkatalog.meta || {
        certification: "CompTIA A+",
        questionCount: 0,
        language: "de",
      },

      allQuestions: fragenkatalog.questions || [],

      coreFilter: "ALL",
      search: "",
      showExplanations: true,
      onlyCorrectHighlight: true,
    };
  },

  computed: {
    filteredQuestions() {
      const s = (this.search || "").toLowerCase();

      return this.allQuestions.filter((q) => {
        // Core Filter
        if (this.coreFilter !== "ALL" && q.core !== this.coreFilter) return false;

        // Suche
        if (!s) return true;

        const haystack =
          (q.question || "") +
          " " +
          Object.values(q.choices || {}).join(" ") +
          " " +
          (q.explanation || "");

        return haystack.toLowerCase().includes(s);
      });
    },
  },

  methods: {
    resetFilter() {
      this.coreFilter = "ALL";
      this.search = "";
      this.showExplanations = true;
      this.onlyCorrectHighlight = true;
    },

    choiceClass(q, key) {
      if (!this.onlyCorrectHighlight) return "";
      return key === q.correct ? "list-group-item-success" : "";
    },
  },
};
</script>

<style scoped>
/* Optional: macht die Liste etwas angenehmer */
.accordion-button {
  gap: 10px;
}
</style>